export default __webpack_public_path__ + "media/images/icons/file-upload-solid-681e2ee37d9b1eb996caff554ff25eb2.svg";